import FirstDisplay from './first-display';
export default FirstDisplay;